import {
    FETCH_SERVICE_ORDER_DETAIL,
    FETCH_SERVICE_ORDER_PRODUCTION_STATISTICS,
    RECEIVE_SERVICE_ORDER_PROCESS_DETAIL,
    FETCH_SERVICE_ORDER_PROCESS_DETAIL,
    RECEIVE_SERVICE_ORDER_DETAIL,
    RECEIVE_SERVICE_ORDER_PRODUCTION_STATISTICS,
    RECEIVE_SERVICE_ORDER_SERVICE_DETAIL,
    FETCH_SERVICE_ORDER_SERVICE_DETAIL,
    POST_SUCCESS_SERVICE_ORDER,
    POST_SERVICE_ORDER,
    FETCH_FOTOGRAFIA_PLANTA,
    RECEIVE_FOTOGRAFIA_PLANTA,
    FETCH_ESTATISTICA_ETAPA,
    RECEIVE_ESTATISTICA_ETAPA,
    FETCH_OS_TIPO_PERGUNTA,
    RECEIVE_OS_TIPO_PERGUNTA,
    FETCH_OS_ESTATISTICA_COLA_VERDE,
    RECEIVE_OS_ESTATISTICA_COLA_VERDE,
    RECEIVE_OPERADORES_ESTATISTICAS,
    FETCH_OPERADORES_ESTATISTICAS,
    FETCH_DIARIO_PRODUCAO,
    RECEIVE_DIARIO_PRODUCAO,
    RECEIVE_TEMPO_ETAPAS,
    FETCH_OS_RECEBIDOS_FINALIZADOS,
    RECEIVE_OS_RECEBIDOS_FINALIZADOS,
    FETCH_ACOMPANHAMENTO_OS,
    RECEIVE_ACOMPANHAMENTO_OS,
    FETCH_LISTA_OS_HEADER,
    RECEIVE_LISTA_OS_HEADER,
    FETCH_TEMPO_ETAPAS,
    FETCH_ORDENS_PARA_CORTE,
    RECEIVE_ORDENS_PARA_CORTE, RECEIVE_OS_MOVIMENTADAS_PERIODO_DETALHADO, FETCH_OS_MOVIMENTADAS_PERIODO_DETALHADO
} from '../actions/actionTypes'
import dataObjectFromFile from "../assets/mock/1/state0.json";

const initialState = () => {


    const at = localStorage.getItem('accessToken');
    if (at && at == "mock") {
        return {
            ...dataObjectFromFile.ordemServicoReducer
        }
    }


    return {
        isFetchingServiceOrder: false,
        isFetchingFotografiaPlanta: false,
        isFetchingDiarioProducao: false,
        isFetchingEstatisticaEtapa: false,
        isFetchingaAompanhamentoOS: false,
        isFetchinglistaOSHeader: false,
        isFetchingEstatisticasOperadores: false,
        isFetchingRecebidosFinalizados: false,
        isFetchingTempoEtapas: false,
        isFetchingOSMovimentadas: false,

        ordemServico: {
            ordemServicoId: null,
            descricao: '',
            pneuModelo: {},
            banda: {},
            pneuMedida: {},
            processo: {},
            ordemServicoEtapas: [],
            productionStatistics: [],
            id: null,
            pneuModeloId: null,
            pneuMedidaId: null,
            bandaId: null,
            processoId: null,
            statusOrdemServicoId: null,

        },
        fotografiaPlanta: [],
        exameInicial: {totais: []},
        escariacao: {totais: []},
        cola: {totais: []},
        colaVerde: [],
        conserto: {totais: []},
        enchimento: {totais: []},
        aplicacaoBanda: {totais: []},
        montagem: {totais: []},
        osContagemPorTipoPergunta: [],
        vulcanizacao: {totais: []},
        exameFinal: {totais: []},
        estatisticaOperadorPorHoraDia: [],
        diarioProducao: [],
        movimentadasPeriodoDetalhada: [],
        acompanhamentoOS: [],
        recebidosFinalizados: [],
        ordensParaCorte: [],
        listaOSHeader: [],
        tempoEtapas: []
    }
}

export default (state = initialState(), action) => {
  switch(action.type) {
      case FETCH_SERVICE_ORDER_DETAIL:
        return {
            ...state,
            isFetchingServiceOrder: true,
            ordemServico: initialState().ordemServico
        }
    case RECEIVE_SERVICE_ORDER_DETAIL:
      //  console.log("reducer OS", action.payload)

        return {
            ...state,
            isFetchingServiceOrder: false,
            ordemServico : action.payload  || initialState().ordemServico
        }
    case POST_SERVICE_ORDER:
        return {
            ...state,
            isPostingServiceOrder: true
        }
    case POST_SUCCESS_SERVICE_ORDER:
        return {
            ...state,
          isPostingServiceOrder: false,
          isSuccessPostingServiceOrder: true,
            ...action.payload
        }
    case FETCH_SERVICE_ORDER_PROCESS_DETAIL:
        return {
            ...state,
            isFetchingServiceOrderProcess: true,
            processData: null,
            ...action.payload
        }
    case RECEIVE_SERVICE_ORDER_PROCESS_DETAIL:
        return {
            ...state,
          isFetchingServiceOrderProcess: false,
          processData: action.payload
        }
    case FETCH_SERVICE_ORDER_SERVICE_DETAIL:
        return {
            ...state,
            isFetchingServiceOrderProcess: true,
            serviceData: {},
            ...action.payload
        }
    case RECEIVE_SERVICE_ORDER_SERVICE_DETAIL:
        return {
            ...state,
          isFetchingServiceOrderProcess: false,
          serviceData: action.payload
        }
      case FETCH_SERVICE_ORDER_PRODUCTION_STATISTICS:
          return {
              ...state,
              isFetchingServiceOrderProductionStatistics: true,
              productionStatistics: []
          }
      case RECEIVE_SERVICE_ORDER_PRODUCTION_STATISTICS:
          return {
              ...state,
              isFetchingServiceOrderProductionStatistics: false,
              productionStatistics: action.payload
          }

      case FETCH_FOTOGRAFIA_PLANTA:
          return {
              ...state,
              isFetchingFotografiaPlanta: true,
              fotografiaPlanta: []
          }

      case RECEIVE_FOTOGRAFIA_PLANTA:
          return {
              ...state,
              isFetchingFotografiaPlanta: false,
              fotografiaPlanta: action.payload
          }

      case FETCH_ESTATISTICA_ETAPA:
          // console.log("action fetch",action);
          let ef = {}
          if (action.payload.etapa === 4) ef = { exameInicial: { totais: [] }};
          if (action.payload.etapa === 4)  ef = { exameInicial: { totais: [] }};
          if (action.payload.etapa === 9)  ef = { escariacao: { totais: [] }};
          if (action.payload.etapa === 12) ef = { conserto: { totais: [] }};
          if (action.payload.etapa === 14) ef = { cola: { totais: [] }};
          if (action.payload.etapa === 16) ef = { enchimento: { totais: [] }};
          if (action.payload.etapa === 18) ef = { aplicacaoBanda: { totais: [] }};
          if (action.payload.etapa === 20) ef = { montagem: { totais: [] }};
          if (action.payload.etapa === 22) ef = { vulcanizacao: { totais: [] }};
          if (action.payload.etapa === 24) ef = { exameFinal: { totais: [] }};

          return {
              ...state,
              isFetchingEstatisticaEtapa: true,
              ...ef
          }

      case RECEIVE_ESTATISTICA_ETAPA:
          // console.log("action receive",action);
          let e1 = {}
       //   console.log("ETAPA REDUCER", action.payload)
          if (action.payload.etapa === 4)  e1 = { exameInicial: { ...action.payload.data } };
          if (action.payload.etapa === 9)  e1 = { escariacao: { ...action.payload.data } };
          if (action.payload.etapa === 12) e1 = { conserto: { ...action.payload.data } };
          if (action.payload.etapa === 14) e1 = { cola: { ...action.payload.data } };
          if (action.payload.etapa === 16) e1 = { enchimento: { ...action.payload.data } };
          if (action.payload.etapa === 18) e1 = { aplicacaoBanda: { ...action.payload.data } };
          if (action.payload.etapa === 20) e1 = { montagem: { ...action.payload.data } };
          if (action.payload.etapa === 22) e1 = { vulcanizacao: { ...action.payload.data } };
          if (action.payload.etapa === 24) e1 = { exameFinal: { ...action.payload.data } };

          return {
              ...state,
              isFetchingEstatisticaEtapa: false,

              ...e1
          }

      case FETCH_OS_TIPO_PERGUNTA:
          return {
              ...state,
          }

      case RECEIVE_OS_TIPO_PERGUNTA:
          var octp = state.osContagemPorTipoPergunta;
          if (action.payload.data && action.payload.data.tipoPergunta) {
              let ix = octp.findIndex(o => o.tipoPergunta === action.payload.data.tipoPergunta);
              if (ix >= 0) {
                  octp[ix] = action.payload.data
              } else {
                  octp.push(action.payload.data)
              }
          }
          return {
              ...state,
              osContagemPorTipoPergunta: octp

          }


      case FETCH_OS_ESTATISTICA_COLA_VERDE:
          return {
              ...state,

              colaVerde: []
          }

      case RECEIVE_OS_ESTATISTICA_COLA_VERDE:
          return {
              ...state,
              colaVerde: action.payload.data.colaVerde,

          }


      case FETCH_OPERADORES_ESTATISTICAS:
          return {
              ...state,
              isFetchingEstatisticasOperadores: true,
              estatisticaOperadorPorHoraDia: [],

          }



      case RECEIVE_OPERADORES_ESTATISTICAS:

          console.log("reducer", action.payload);
          return {
              ...state,
              isFetchingEstatisticasOperadores: false,
              estatisticaOperadorPorHoraDia: action.payload.data.estatisticaOperadorPorHoraDia,

          }


      case FETCH_DIARIO_PRODUCAO:
          return {
              ...state,
              isFetchingDiarioProducao: true,
              diarioProducao: [],

          }
      case RECEIVE_DIARIO_PRODUCAO:
          return {
              ...state,
              isFetchingDiarioProducao: false,
              diarioProducao: action.payload.data? action.payload.data.diarioProducao : [],

          }

      case FETCH_OS_MOVIMENTADAS_PERIODO_DETALHADO:
          return {
              ...state,
              isFetchingOSMovimentadas: true,
              movimentadasPeriodoDetalhada: []
          }
      case RECEIVE_OS_MOVIMENTADAS_PERIODO_DETALHADO:
          return {
              ...state,
              isFetchingOSMovimentadas: false,
              movimentadasPeriodoDetalhada: action.payload.data? action.payload.data.movimentadasPeriodoDetalhada : [],

          }

      case FETCH_ACOMPANHAMENTO_OS:
          return {
              ...state,
              isFetchingaAompanhamentoOS: true,
              acompanhamentoOS: [],

          }
      case RECEIVE_ACOMPANHAMENTO_OS:

          return {
              ...state,
              isFetchingaAompanhamentoOS: false,
              acompanhamentoOS: action.payload.data? action.payload.data.acompanhamentoOS : [],

          }


      case FETCH_OS_RECEBIDOS_FINALIZADOS:
          return {
              ...state,
              isFetchingRecebidosFinalizados: true,
              recebidosFinalizados: []
          }

      case RECEIVE_OS_RECEBIDOS_FINALIZADOS:

          console.log("RECEIVE_OS", action.payload);

          return {
              ...state,
              isFetchingRecebidosFinalizados: false,
              recebidosFinalizados: action.payload.recebidosFinalizados
          }

      case FETCH_TEMPO_ETAPAS:
          return {
                ...state,
              isFetchingTempoEtapas: true,
              tempoEtapas: [],

      }

      case RECEIVE_TEMPO_ETAPAS:

          return {
              ...state,
              isFetchingTempoEtapas: false,
              tempoEtapas: action.payload.data? action.payload.data.tempoEtapas : [],

          }

      case FETCH_LISTA_OS_HEADER:


          return {
              ...state,
              isFetchinglistaOSHeader: true,
              listaOSHeader: [],

          }
      case RECEIVE_LISTA_OS_HEADER:

            console.log("receive_lista_os", action.payload)
          return {
              ...state,
              isFetchinglistaOSHeader: false,
              listaOSHeader: action.payload.data? action.payload.data.listaOSHeader : [],

          }

      case FETCH_ORDENS_PARA_CORTE:
            return {
                ...state,
            }

      case RECEIVE_ORDENS_PARA_CORTE:
          console.log("Reducer Receive Ordens para Corte");
             return {
                 ...state,
                 ordensParaCorte: action.payload.data.ordensParaCorte
             }


      default:
            return state;
  }
}
